<template>
  <v-container>
    <div class="scroll-menu pl-0" ref="scrollMenu">
      <!-- Botões de categoria do menu de rolagem horizontal -->
      <v-btn
        v-for="(categoria, catIndex) in cardapio"
        :key="catIndex"
        class="scroll-menu__item ml-0"
        :class="{ 'active': catIndex === activeCategory }"
        text
        @click="scrollToCategory(catIndex)"
        outline
        ref="categoryButtons"
      >{{ categoria.nome }}</v-btn>
    </div>
    <v-layout row>
      <v-flex>
        <div v-for="(categoria, catIndex) in cardapio" :key="catIndex" :id="'categoria-' + catIndex">
          <template v-if="filtro.content === '' || JSON.stringify(categoria.produtos).toLowerCase().includes(filtro.content.toLowerCase())">
            <div class="h5 mx-0 px-0 font-weight-bold">{{ categoria.nome }}</div>
            <template v-if="categoria.texto && categoria.texto !== ''">
              <div class="secondary--text text--lighten-1 caption mx-0 px-0 pb-3" v-html="categoria.texto"></div>
              <v-divider></v-divider>
            </template>
            <v-row>
              <v-col v-for="(item, index) in categoria.produtos" :key="item.id" :cols="12" :sm="6" :md="4" :lg="3">
                <template v-if="filtro.content === '' || JSON.stringify(item).toLowerCase().includes(filtro.content.toLowerCase())">
                  <v-card @click="$emit('clique-no-produto', index, catIndex)" class="mb-4">
                    <v-card-text class="pa-0">
                      <v-layout>
                        <v-flex shrink v-if="item.doc.img && item.doc.img.length > 0 && item.doc.img[0] !== ''">
                          <v-img
                              :src="item.doc.img[0]"
                              height="100%"
                              width="100px"
                              class="img-left"
                            ></v-img>
                        </v-flex>
                        <v-flex>
                          <div class="ma-3">
                              <div class="body-1 font-weight-bold" v-html="item.nome"></div>
                              <div class="caption grey--text" v-html="tiraQuebrasDeLinhas(item.descricao)"></div>
                              <div class="mt-2">
                                <div v-if="item.doc.valorantigo && parseFloat(item.doc.valorantigo) > 0 && parseFloat(item.doc.valorantigo) > parseFloat(item.doc.condicao[0].valor)">
                                  <div class="caption text-decoration-line-through grey--text">De R$ {{ parseFloat(item.doc.valorantigo).toFixed(2).replace('.', ',') }}</div>
                                  <div class="caption success--text font-weight-bold">Por R$ {{ parseFloat(item.doc.condicao[0].valor).toFixed(2).replace('.', ',') }}</div>
                                </div>
                                <div v-else class="caption">R$ {{ parseFloat(item.doc.condicao[0].valor).toFixed(2).replace('.', ',') }}</div>
                              </div>
                            </div>
                            <div>
                              <!--
                              <v-btn absolute bottom right color="success" small fab
                                v-if="!item.doc.adicionais.length > 0 && (!item.doc.variacao || (item.doc.variacao == false || item.doc.variacao == 'false'))" @click.stop="$emit('clique-no-botao-inserir', {
                                qtd: 1,
                                nome: item.nome,
                                id: item.id,
                                valor: parseFloat(item.doc.condicao[0].valor),
                                subtotal: parseFloat(item.doc.condicao[0].valor),
                                opcionais: null
                              })">
                                <v-icon>shopping_cart</v-icon>
                              </v-btn>
                              <v-btn absolute bottom right color="success" small fab
                                v-else @click.stop="$emit('clique-no-produto', index, catIndex)"
                              >
                            -->
                            <v-btn absolute bottom right color="success" small fab @click.stop="$emit('clique-no-produto', index, catIndex)">
                              <v-icon>shopping_cart</v-icon>
                            </v-btn>
                            </div>
                        </v-flex>
                      </v-layout>      
                    </v-card-text>
                  </v-card>
                </template>
              </v-col>
            </v-row>
          </template>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: ['cardapio', 'filtro'],
  data() {
    return {
      activeCategory: null,
      menuOffsetTop: 0,
    };
  },
  methods: {
    tiraQuebrasDeLinhas(text) {
      let novo = text.replace(/<br>/g, ' ');
      return novo.substring(0, 99);
    },
    scrollToCategory(index) {
      const element = document.getElementById('categoria-' + index);
      if (element) {
        const offsetPosition = element.getBoundingClientRect().top + window.scrollY - 73;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    },
    handleScroll() {
      const scrollMenu = this.$refs.scrollMenu;
      if (window.scrollY > this.menuOffsetTop) {
        scrollMenu.classList.add('fixed');
      } else {
        scrollMenu.classList.remove('fixed');
      }

      this.cardapio.forEach((categoria, index) => {
        const element = document.getElementById('categoria-' + index);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 80 && rect.bottom > 80) {
            this.activeCategory = index;
            this.scrollMenuToButton(index);
          }
        }
      });
    },
    scrollMenuToButton(index) {
      this.$nextTick(() => {
        const buttons = this.$refs.categoryButtons;
        const button = buttons && buttons[index] && buttons[index].$el;
        if (button) {
          const menu = this.$refs.scrollMenu;
          const menuRect = menu.getBoundingClientRect();
          const buttonRect = button.getBoundingClientRect();

          if (buttonRect.left < menuRect.left || buttonRect.right > menuRect.right) {
            button.scrollIntoView({ behavior: 'smooth', inline: 'center' });
          }
        }
      });
    },
  },
  mounted() {
    this.menuOffsetTop = this.$refs.scrollMenu.offsetTop;
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style scoped>
.scroll-menu {
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  padding: 10px;
  background: white;
  z-index: 10;
  position: relative; /* Ensures the z-index applies within the component */
}

.scroll-menu.fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.scroll-menu__item {
  display: inline-block;
  margin: 0 10px;
}

.scroll-menu__item.active {
  background-color: #54575a !important;
  color: white;
}

.priceAct {
  min-width: 79px !important;
}

.priceLabel div {
  white-space: nowrap;
}

.productImage {
  height: 100% !important;
}
</style>
